import { Company } from "@finway-group/shared/lib/models"
import { Input, Menu } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import CompanyLogo from "~Components/company/CompanyLogo"
import { KeySelector, useSearch } from "~Shared/hooks/search.hooks"

interface SubCompanyListProps {
    userCompanies: Array<Company>
    keySelector: KeySelector<Company>
    onCompanySelect: (company: Company) => void
}

export const SubCompanyList = ({ userCompanies, keySelector, onCompanySelect, ...antdProps }: SubCompanyListProps) => {
    const { t } = useTranslation()
    const { searchTerm, searchResults, handleInputChange, handleInputClick } = useSearch(userCompanies, keySelector)

    return (
        <Menu className="flex flex-col min-w-200">
            <Menu.Item>
                <Input type="text" placeholder={t("action:inbox_invoice.search")} value={searchTerm} onChange={handleInputChange} onClick={handleInputClick} />
            </Menu.Item>

            {searchResults.map((company) => (
                <Menu.Item
                    key={company._id}
                    {...antdProps}
                    icon={<CompanyLogo {...company} />}
                    style={{ display: "flex", gap: "8px", alignItems: "center" }}
                    onClick={({ domEvent }) => {
                        domEvent.stopPropagation()
                        onCompanySelect(company)
                    }}
                >
                    <span className="text-text leading-none">{keySelector(company)}</span>
                </Menu.Item>
            ))}
        </Menu>
    )
}
